export default "__VITE_ASSET__f71ce826__"